document.documentElement.classList.remove('no-js');

function syncProductSupplyBadge(gallery, mediaId) {
  const badge = gallery?.querySelector('[data-product-supply-badge]');
  const featuredMediaId = gallery?.dataset.featuredMediaId;
  if (!badge || !featuredMediaId || !mediaId) return;
  badge.hidden = String(mediaId) !== String(featuredMediaId);
}

document.addEventListener('click', function (event) {
  const mediaTrigger = event.target.closest('[data-product-thumbnail]');
  if (mediaTrigger) {
    const gallery = mediaTrigger.closest('[data-product-gallery]');
    const image = gallery?.querySelector('[data-product-main-image] img');
    if (image && mediaTrigger.dataset.mediaSrc) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = mediaTrigger.dataset.mediaSrc;
      image.alt = mediaTrigger.dataset.mediaAlt || '';
      gallery.querySelectorAll('[data-product-thumbnail]').forEach(function (button) {
        const isCurrent = button === mediaTrigger;
        button.classList.toggle('is-active', isCurrent);
        if (isCurrent) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      syncProductSupplyBadge(gallery, mediaTrigger.dataset.mediaId);
    }
    return;
  }

  const trigger = event.target.closest('[data-quantity-change]');
  if (!trigger) return;
  const wrapper = trigger.closest('[data-quantity]');
  const input = wrapper && wrapper.querySelector('input[type="number"]');
  if (!input) return;
  const change = Number(trigger.dataset.quantityChange || 0);
  const minimum = Number(input.min || 1);
  input.value = Math.max(minimum, Number(input.value || minimum) + change);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('change', function (event) {
  const sort = event.target.closest('[data-collection-sort]');
  if (sort) {
    if (sort.form?.requestSubmit) sort.form.requestSubmit();
    else sort.form?.submit();
    return;
  }

  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const product = select.closest('[data-product-buy]');
  const price = product?.querySelector('[data-product-price]');
  const compare = product?.querySelector('[data-product-compare]');
  const addButton = product?.querySelector('[data-add-to-cart]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (compare) {
    const hasSaving = Number(option.dataset.compareCents || 0) > Number(option.dataset.priceCents || 0);
    compare.hidden = !hasSaving;
    if (hasSaving && option.dataset.comparePrice) compare.textContent = option.dataset.comparePrice;
  }
  if (addButton) {
    const available = option.dataset.available === 'true' && !option.disabled;
    addButton.disabled = !available;
    addButton.innerHTML = available ? 'ADD TO YOUR ROUTINE <span aria-hidden="true">→</span>' : 'SOLD OUT';
  }
  if (option.dataset.mediaSrc) {
    const gallery = product?.closest('.koero-product-buy')?.querySelector('[data-product-gallery]');
    const image = gallery?.querySelector('[data-product-main-image] img');
    if (image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = option.dataset.mediaSrc;
      image.alt = option.dataset.mediaAlt || '';
      gallery.querySelectorAll('[data-product-thumbnail]').forEach(function (button) {
        const isCurrent = button.dataset.mediaSrc === option.dataset.mediaSrc;
        button.classList.toggle('is-active', isCurrent);
        if (isCurrent) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      syncProductSupplyBadge(gallery, option.dataset.mediaId);
    }
  }
  if (option.dataset.variantUrl && window.history?.replaceState) {
    window.history.replaceState({}, '', option.dataset.variantUrl);
  }
});

function initKoeroMobileMenus(root = document) {
  const menus = root.matches?.('.koero-mobile-menu') ? [root] : root.querySelectorAll?.('.koero-mobile-menu');
  if (!menus) return;

  menus.forEach(function (menu) {
    if (menu.dataset.menuReady === 'true') return;
    menu.dataset.menuReady = 'true';
    const summary = menu.querySelector('summary');
    if (!summary) return;

    function syncState() {
      summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    }

    syncState();
    menu.addEventListener('toggle', syncState);
    menu.addEventListener('click', function (event) {
      if (event.target.closest('.koero-mobile-menu__panel a')) menu.open = false;
    });
    menu.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !menu.open) return;
      menu.open = false;
      summary.focus();
    });
  });
}

function closeKoeroMobileMenus(event) {
  document.querySelectorAll('.koero-mobile-menu[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
}

function initKoeroHeader() {
  const header = document.querySelector('.koero-header');
  if (!header || header.dataset.headerReady === 'true') return;
  header.dataset.headerReady = 'true';
  const syncHeader = function () {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });
}

function initKoeroEmailPopup(root = document) {
  const popup = root.matches?.('[data-koero-popup]') ? root : root.querySelector?.('[data-koero-popup]');
  if (!popup || popup.dataset.popupReady === 'true') return;
  popup.dataset.popupReady = 'true';

  const storageKey = 'koeroEmailPopupDismissedAt';
  const delay = Math.max(0, Number(popup.dataset.delay || 8)) * 1000;
  const hideFor = Math.max(1, Number(popup.dataset.hideDays || 14)) * 86400000;
  const closeButtons = popup.querySelectorAll('[data-popup-close]');
  const success = popup.querySelector('[data-popup-success]');
  const error = popup.querySelector('[data-popup-error]');
  let lastFocus = null;
  let timer = null;

  function getDismissedAt() {
    try { return Number(window.localStorage.getItem(storageKey) || 0); } catch (storageError) { return 0; }
  }

  function rememberDismissal() {
    try { window.localStorage.setItem(storageKey, String(Date.now())); } catch (storageError) { /* Storage may be unavailable. */ }
  }

  function openPopup() {
    if (!popup.hidden) return;
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('koero-dialog-open');
    window.requestAnimationFrame(function () {
      const focusTarget = popup.querySelector('input, button, a[href]');
      if (focusTarget) focusTarget.focus();
    });
  }

  function closePopup(remember = true) {
    if (remember) rememberDismissal();
    popup.hidden = true;
    document.documentElement.classList.remove('koero-dialog-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () { closePopup(true); });
  });

  document.addEventListener('keydown', function (event) {
    if (popup.hidden) return;
    if (event.key === 'Escape') {
      closePopup(true);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (success || error) {
    openPopup();
  } else if (Date.now() - getDismissedAt() >= hideFor) {
    timer = window.setTimeout(openPopup, delay);
  }

  popup.addEventListener('koero:popup:open', openPopup);
  popup.addEventListener('koero:popup:close', function () { closePopup(false); });
  popup.dataset.popupTimer = timer ? 'active' : 'inactive';
}

document.addEventListener('DOMContentLoaded', function () {
  initKoeroEmailPopup(document);
  initKoeroMobileMenus(document);
  initKoeroHeader();
});

document.addEventListener('click', closeKoeroMobileMenus);

document.addEventListener('shopify:section:load', function (event) {
  initKoeroEmailPopup(event.target);
  initKoeroMobileMenus(event.target);
});

document.addEventListener('shopify:section:select', function (event) {
  const popup = event.target.querySelector?.('[data-koero-popup]');
  if (popup) popup.dispatchEvent(new CustomEvent('koero:popup:open'));
});
